import useFetch from 'core/redux/hooks/useFetch';
import fetchCards from 'app/games/taboo/actions/fetchCards';

export default function useFetchCards() {
  return useFetch(fetchCards);
}
